import React from "react";
import PropTypes from "prop-types";
import { documentPropType } from "custom-prop-types";
import { reduxForm } from "redux-form";
import { FormButton, renderFormElement } from "components/common/form-elements";
import styles from "components/upload-documents/processing-fields.scss";
import { Button } from "components/common/button";
import { DocumentTypeSelector } from "components/upload-documents/processing-fields";


const PendingOtherDocumentForm = ({
  documentType,
  focusedDocument,
  onChangeDocumentType,
  onReprocessPendingDocument,
  onSavePendingOtherDocument,
  onShowTrashDocument
}) => (
  <form onSubmit={ (e) => { e.preventDefault(); onSavePendingOtherDocument(); } }>
    <DocumentTypeSelector documentType={ documentType } onChangeDocumentType={ onChangeDocumentType } />
    { renderFormElement("Name", "name", "text") }
    { renderFormElement("Date", "issued", "date") }
    { renderFormElement("Notes", "notes", "notes") }
    <div className={ styles.trash }>
      <Button danger onClick={ () => { onShowTrashDocument(); } }>Trash</Button>
      <span className={ styles.reprocess }>
        <Button onClick={ () => { onReprocessPendingDocument(focusedDocument); } }>Process Automatically</Button>
      </span>
    </div>
    <div className={ styles.save }>
      <FormButton text={ "Save" } />
    </div>
  </form>
);

PendingOtherDocumentForm.propTypes = {
  documentType: PropTypes.string.isRequired,
  focusedDocument: documentPropType.isRequired,
  onChangeDocumentType: PropTypes.func.isRequired,
  onReprocessPendingDocument: PropTypes.func.isRequired,
  onSavePendingOtherDocument: PropTypes.func.isRequired,
  onShowTrashDocument: PropTypes.func.isRequired
};

export const OtherFields = reduxForm({ form: "pendingOtherDocumentForm" })(PendingOtherDocumentForm);



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/other-fields.jsx